import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { useLang } from "@/contexts/LanguageContext";
import { Trash } from "@phosphor-icons/react";

export default function CartPage() {
  const { items, removeItem, updateQty, total } = useCart();
  const { t } = useLang();

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-12" data-testid="cart-page">
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mb-10">{t.cart.title}</h1>
      {items.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-neutral-300" data-testid="cart-empty">
          <p className="text-neutral-500 mb-6">{t.cart.empty}</p>
          <Link to="/shop" className="vt-btn-primary">{t.cart.continueShopping}</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-[1fr_360px] gap-10">
          <div className="border border-neutral-200">
            {items.map((item, idx) => {
              const key = item.key || item.id;
              return (
              <div key={key} className={`p-4 flex gap-4 items-center ${idx > 0 ? "border-t border-neutral-200" : ""}`} data-testid={`cart-item-${key}`}>
                <img src={item.image} alt={item.name} className="w-24 h-24 object-cover border border-neutral-200" />
                <div className="flex-1">
                  <Link to={`/product/${item.slug}`} className="font-bold hover:text-[color:var(--vt-orange)]">{item.name}</Link>
                  <div className="text-sm text-neutral-500">€{item.price.toFixed(2)}</div>
                  {item.variant_sku && <div className="text-[11px] text-neutral-400 font-mono">SKU: {item.variant_sku}</div>}
                </div>
                <div className="flex border border-black">
                  <button onClick={() => updateQty(key, item.quantity - 1)} className="w-8 h-8 hover:bg-black hover:text-white transition-colors">-</button>
                  <div className="w-10 h-8 flex items-center justify-center border-x border-black font-bold text-sm">{item.quantity}</div>
                  <button onClick={() => updateQty(key, item.quantity + 1)} className="w-8 h-8 hover:bg-black hover:text-white transition-colors">+</button>
                </div>
                <div className="font-bold w-24 text-right">€{(item.price * item.quantity).toFixed(2)}</div>
                <button onClick={() => removeItem(key)} className="text-neutral-500 hover:text-red-600" data-testid={`remove-${key}`}>
                  <Trash size={18} />
                </button>
              </div>
              );
            })}
          </div>
          <aside className="border border-neutral-200 p-6 h-fit">
            <h3 className="font-display font-bold text-xl mb-4">Summary</h3>
            <div className="flex justify-between mb-2 text-sm"><span>{t.cart.subtotal}</span><span>€{total.toFixed(2)}</span></div>
            <div className="flex justify-between mb-4 text-sm text-neutral-500"><span>Shipping</span><span>Calculated at checkout</span></div>
            <div className="flex justify-between font-black text-2xl mb-6 pt-4 border-t border-neutral-200"><span>Total</span><span>€{total.toFixed(2)}</span></div>
            <Link to="/checkout" className="vt-btn-orange w-full" data-testid="cart-checkout-btn">{t.cart.checkout}</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
